import React from 'react';
import UploadAndSubmit from '../components/UploadJson';
import UploadImage from '../components/UploadImage';
import '../css/ContentMakerPage.css';
function ContentMakerPage() { 
  return (
    <div className="content-maker-page">
    <div className="component-wrapper">
      <h1>Upload Content to DataBase</h1>
      <UploadAndSubmit />
    </div>
    <div className="component-wrapper">
      <h1>Upload Images to AWS S3</h1>
      <UploadImage />
    </div>
  </div>
  );
}

export default ContentMakerPage;
